"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireDefault(require("react")),
    _uiKit = require("@devsta/ui-kit"),
    Filter = function Filter(a) {
  var b = a.searchTerm,
      c = a.onSearch;
  return _react["default"].createElement("div", {
    className: "comments-tab-container__filter-container"
  }, _react["default"].createElement(_uiKit.Input, {
    id: "filter-search",
    prefix: "search",
    placeholder: "Search",
    onChange: c,
    value: b,
    clearButton: _react["default"].createElement(_uiKit.Icon, {
      name: "close",
      size: 10,
      color: "regent"
    })
  }));
},
    _default = Filter;

exports["default"] = _default;